import ImagesPicker from './ImagesPicker';

export default ImagesPicker;
